<template>
    <div class="modal-card card">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">Edit Parameter Values</h4>
            <!-- Close -->
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="card-body">
            <div class="table-responsive">
                <table class="table table-sm table-nowrap mt-2">
                    <thead>
                        <tr class="">
                            <th class="col-sm-4">Name</th>
                            <th class="col-sm-3">Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(param, index) in parameters" :key="index">
                            <td class="col-sm-4 px-1 py-2">
                                <input style="padding: 2px 7px;" class="form-control" type="text" :disabled="true"
                                    v-model="parameters[index].name" />
                            </td>
                            <td class="col-sm-3 px-1 py-2">
                                <input style="padding: 2px 7px;" class="form-control" type="text"
                                    v-model="parameters[index].value" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card-footer text-end">
            <button class="btn btn-success" :disabled="saving" @click="saveParameters">
                <div v-if="saving" class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <div v-else>
                    Save
                </div>
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    data() {
        return {
            parameters: [],
            saving: false,
            selectedSandbox: this.$route.params.sandboxId
        }
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    beforeMount() {
        this.parameters = JSON.parse(JSON.stringify(this.$store.state.amdp.lakeviewParameters)) // deep clone
    },
    computed:{
        isProdV2Sandbox() {
            const sandboxes = this.$store.state.sandbox.prodV2Sandboxes;
            return sandboxes.some((sandbox) => sandbox.name === this.selectedSandbox);
        },
    },
    methods: {
        ...mapActions({
            fetchParameters: "amdp/fetchLakeviewParameters",
            updateParameters: "amdp/updateLakeviewParameters",
            updateProdV2PromotionDirect: "sandbox/updateProdV2PromotionDirect",
        }),
        async saveParameters() {
            this.saving = true;
            let toastOptions;
            const sandboxName = this.$route.params.sandboxId;
            const jobName = this.$route.params.jobId;
            const fetchOpts = { sandboxName, jobName };
            const payload = { parameters: this.parameters };

            try {
                if (!this.isProdV2Sandbox) {
                    await this.updateParameters({
                        sandboxName,
                        jobName,
                        payload,
                    });
                } else {
                    await this.updateProdV2PromotionDirect({
                        sandboxId: sandboxName,
                        jobName,
                        payload,
                    });
                }
                toastOptions = {
                    message: "Default values updated successfully.",
                    type: "success",
                };
                this.fetchParameters(fetchOpts);
                this.$store.dispatch('hideModal');
            } catch (error) {
                const err =
                    error.response?.data?.error != null
                        ? error.response.data.error
                        : error.message;
                toastOptions = {
                    message: err || "Something went wrong when updating parameters. Please contact support.",
                    type: "error",
                };
            } finally {
                this.saving = false;
                this.$store.dispatch("addToast", toastOptions);
            }
        },
    }
}
</script>

<style></style>